import { createContext, useContext } from 'react';
import { FEEDER_FIELDS, type FeederConfig } from '../feederFields';

/**
 * The feeder payload in force for everything on screen: the draft's `feederFields` when it
 * has one, else the built-in list. `AppLayout` provides it from the shared draft, so an edit
 * saved on Field Management reaches the rule editor's field lists and source buttons at once.
 *
 * The default is the built-in list, so a component mounted on its own (the editor tests,
 * the Blocks harness) sees exactly what it saw before the payload became configuration.
 */
export const FeederConfigContext = createContext<FeederConfig>(FEEDER_FIELDS);

export function useFeederConfig(): FeederConfig {
  return useContext(FeederConfigContext);
}
